var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"white","flat":""}},[_c('span',{staticStyle:{}},[_vm._v(_vm._s(_vm.siteName))]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }